import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from "rxjs/Observable";
import * as globalConst from './../../../constants';

import * as moment from 'moment';

@Injectable()
export class ProposalService {
	private apiUrl = globalConst.baseAPI;  // URL para web api
	constructor(private http: Http) { }

	getEconomicGroups(userID, empresaID) {

		var url;

		if (empresaID) {
			url = userID + "/" + empresaID;
		} else {
			url = userID;
		}

		return this.http
			.get(this.apiUrl + "/economicgroup/v1/getcodclient/" + url, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getUserProfileByClient(accountClientId) {
		return this.http
			.get(this.apiUrl + "commercialstructurepaper/v1/getuserprofile/" + accountClientId, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getClientTypes(token) {
		return this.http
			.get(this.apiUrl + "clienttypes/v1/getclienttypes?$filter=Ativo eq true&$orderby=Nome", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getSegmentTypes(token) {
		return this.http
			.get(this.apiUrl + "segments/v1/segments?$filter=Ativo eq true&$orderby=Descricao", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getStatus(token) {
		return this.http
			.get(this.apiUrl + "report/v1/proposal/status", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getCTC(token) {
		return this.http
			.get(this.apiUrl + "commercialstructure/v1/getcommercialstructurebypapel/C?$filter=Ativo eq true&$orderby=Nome", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getGC(token) {
		return this.http
			.get(this.apiUrl + "commercialstructure/v1/getcommercialstructurebypapel/G?$filter=Ativo eq true&$orderby=Nome", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getDirector(token) {
		return this.http
			.get(this.apiUrl + "commercialstructure/v1/getcommercialstructurebypapel/D?$filter=Ativo eq true&$orderby=Nome", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getSuper(token, id) {
		return this.http
			.get(this.apiUrl + "commercialstructure/v1/getcommercialstructurebymaster/" + id + "?$filter=Ativo eq true&$orderby=Nome", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getAnalyst(token) {
		return this.http
			.get(this.apiUrl + "profilestructure/v1/profile/analyst?&$orderby=Nome", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	search(token, proposta, orderby, sort, page) {

		var json = {
			TipoProposta: proposta.TipoProposta == '' ? null : proposta.TipoProposta,
			CodigoProposta: proposta.CodigoProposta == '' ? null : proposta.CodigoProposta,
			NomeCliente: proposta.Cliente == '' ? null : proposta.Cliente,
			Status: proposta.Status == '' ? null : proposta.Status,
			ValorProposta: proposta.ValorProposta == '' ? null : proposta.ValorProposta,
			Vigencia: (proposta.Vigencia == '' || proposta.Vigencia == null || proposta.Vigencia == undefined) ? null : moment(proposta.Vigencia["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
			VigenciaFim: (proposta.VigenciaFim == '' || proposta.VigenciaFim == null || proposta.VigenciaFim == undefined) ? null : moment(proposta.VigenciaFim["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
			Rating: proposta.Rating == '' ? null : proposta.Rating,
			TipoCliente: proposta.TipoCliente == '' ? null : proposta.TipoCliente,
			Segmento: proposta.Segmento == '' ? null : proposta.Segmento,
			Diretoria: proposta.Diretoria == '' ? null : proposta.Diretoria,
			GC: proposta.GC == '' ? null : proposta.GC,
			CTC: proposta.CTC == '' ? null : proposta.CTC,
			DataCriacao: (proposta.DataCriacao == '' || proposta.DataCriacao == null || proposta.DataCriacao == undefined) ? null : moment(proposta.DataCriacao["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
			DataCriacaoFim: (proposta.DataCriacaoFim == '' || proposta.DataCriacaoFim == null || proposta.DataCriacaoFim == undefined) ? null : moment(proposta.DataCriacaoFim["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
			DataConclusao: (proposta.DataConclusao == '' || proposta.DataConclusao == null || proposta.DataConclusao == undefined) ? null : moment(proposta.DataConclusao["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
			DataConclusaoFim: (proposta.DataConclusaoFim == '' || proposta.DataConclusaoFim == null || proposta.DataConclusaoFim == undefined) ? null : moment(proposta.DataConclusaoFim["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
			DataEntregue: (proposta.DataEntrega == '' || proposta.DataEntrega == null || proposta.DataEntrega == undefined) ? null : moment(proposta.DataEntrega["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
			DataEntregueFim: (proposta.DataEntregaFim == '' || proposta.DataEntregaFim == null || proposta.DataEntregaFim == undefined) ? null : moment(proposta.DataEntregaFim["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
			Analista: proposta.Analista == '' ? null : proposta.Analista,
			Documento: proposta.Documento == '' ? null : proposta.Documento.replace(/[^a-zA-Z0-9]+/g, ''),
			LeadTime: proposta.LeadTime == '' ? null : parseInt(proposta.LeadTime),
			LeadTimeFim: proposta.LeadTimeFim == '' ? null : parseInt(proposta.LeadTimeFim)
		};

		return this.http
			.post(this.apiUrl + "report/v1/proposal/search?$orderby=" + orderby + " " + sort + "&$top=" + globalConst.paginationSkip + "&$skip=" + page + "", json, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	export(token, proposta) {

		var json = {
			TipoProposta: proposta.TipoProposta == '' ? null : proposta.TipoProposta,
			CodigoProposta: proposta.CodigoProposta == '' ? null : proposta.CodigoProposta,
			NomeCliente: proposta.Cliente == '' ? null : proposta.Cliente,
			Status: proposta.Status == '' ? null : proposta.Status,
			ValorProposta: proposta.ValorProposta == '' ? null : proposta.ValorProposta,
			Vigencia: proposta.Vigencia == '' ? null : moment(proposta.Vigencia["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
			VigenciaFim: proposta.VigenciaFim == '' ? null : moment(proposta.VigenciaFim["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
			Rating: proposta.Rating == '' ? null : proposta.Rating,
			TipoCliente: proposta.TipoCliente == '' ? null : proposta.TipoCliente,
			Segmento: proposta.Segmento == '' ? null : proposta.Segmento,
			Diretoria: proposta.Diretoria == '' ? null : proposta.Diretoria,
			GC: proposta.GC == '' ? null : proposta.GC,
			CTC: proposta.CTC == '' ? null : proposta.CTC,
			DataCriacao: proposta.DataCriacao == '' ? null : moment(proposta.DataCriacao["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
			DataCriacaoFim: proposta.DataCriacaoFim == '' ? null : moment(proposta.DataCriacaoFim["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
			DataConclusao: proposta.DataConclusao == '' ? null : moment(proposta.DataConclusao["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
			DataConclusaoFim: proposta.DataConclusaoFim == '' ? null : moment(proposta.DataConclusaoFim["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
			DataEntregue: proposta.DataEntrega == '' ? null : moment(proposta.DataEntrega["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
			DataEntregueFim: proposta.DataEntregaFim == '' ? null : moment(proposta.DataEntregaFim["jsdate"]).format("YYYY-MM-DD HH:mm:ss"),
			Analista: proposta.Analista == '' ? null : proposta.Analista,
			Documento: proposta.Documento == '' ? null : proposta.Documento,
			LeadTime: proposta.LeadTime == '' ? null : parseInt(proposta.LeadTime),
			LeadTimeFim: proposta.LeadTimeFim == '' ? null : parseInt(proposta.LeadTimeFim)
		};

		let localStorageOptions = JSON.parse(localStorage.getItem('yara.connectionHeader'));

		const options = new RequestOptions({ headers: localStorageOptions.headers, responseType: ResponseContentType.Blob });

		return this.http
			.post(this.apiUrl + "report/v1/proposal/export", json, options)
			.map(res => {
				return new Blob([res.blob()], { type: "application/octet-stream" });
			});
	}
}



// WEBPACK FOOTER //
// ./src/app/report/service/proposal.service.ts